import { render, staticRenderFns } from "./newEventModal.vue?vue&type=template&id=c1cf9d22&"
import script from "./newEventModal.vue?vue&type=script&lang=js&"
export * from "./newEventModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports